import React from 'react';
import { gql } from '@apollo/client';
import './principal.css';

// Dashboard de Nawaiam de una cuenta empresa: de ahí se traen sus players. La clave de la cuenta (empresaKey) ES el
// nombre del dashboard; las cuentas creadas "sin dashboard" llevan la clave SIN_DASHBOARD y no traen players.
export const esSinDashboard = (k) => !k || String(k).trim().toLowerCase() === 'sin_dashboard';

export const ESTADO_DASHBOARD = gql`
  query EstadoDashboardNawaiam($companyName: String!) {
    estadoDashboardNawaiam(companyName: $companyName) { nombre existe personas error sinDashboard }
  }
`;

// Etiqueta "Dashboard Nawaiam: X" (o el aviso de que no tiene). compacta: para celdas de tabla.
export function EtiquetaDashboard({ nombre, compacta = false }) {
  if (esSinDashboard(nombre)) {
    return <span className="op-dash op-dash--sin" title="La cuenta no está vinculada a un dashboard de Nawaiam">{compacta ? 'Sin dashboard' : 'Sin dashboard de Nawaiam: no trae players'}</span>;
  }
  return (
    <span className="op-dash" title="Dashboard de Nawaiam del que se traen los players de esta cuenta">
      {!compacta && <span className="op-dash-rotulo">Dashboard Nawaiam</span>}
      <b>{nombre}</b>
    </span>
  );
}
